<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="DepartmentForm ">
        <div class="col-lg-12 col-md-12">
            <div class="card-body">
                <div class="bc d-flex align-items-center pl-3" *ngIf="submitButton">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                            Department
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            Add New Department Record
                        </p>
                    </div>
                </div>
                <div class="bc d-flex align-items-center pl-3" *ngIf="editButton">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                            Department
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            Update New Department Record
                        </p>
                    </div>
                </div>
                <div class="bc d-flex align-items-center pl-3" *ngIf="deleteButton">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                            Department
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            Delete New Department Record
                        </p>
                    </div>
                </div>
                <hr>
                <div class="row clearfix">
                    <div class="col-sm-4">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Faculty</mat-label>
                            <mat-select [disabled]="isreaddelete" required #select33 placeholder="" class="colorblack"
                          formControlName="FcCode">
                          <mat-select-filter *ngIf="select33.focused" [placeholder]="'Filter'"
                            [displayMember]="'FcDesc'" [array]="fcCodeList"
                            (filteredReturn)="filteredListFcCode =$event">
                          </mat-select-filter>
                          <mat-option *ngFor="let item of filteredListFcCode" [value]="item.FcCode">
                            {{item.FcCode}} - {{item.FcDesc}}
                          </mat-option>
                        </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="DepartmentForm.controls['FcCode'].touched && DepartmentForm.controls['FcCode'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <div class="">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>Department Code</mat-label>
                                    <input appUppercase onkeydown="return (event.keyCode!=13);" [readonly]="isread || isreaddelete"
                                        maxlength="5" class="color" matInput formControlName="DeptCode"
                                        placeholder="Department Code" required>
                                    <mat-error class="margin_tp"
                                        *ngIf="DepartmentForm.controls['DeptCode'].touched && DepartmentForm.controls['DeptCode'].errors?.required">
                                        Mandatory
                                    </mat-error>
                                    <mat-error class="margin_tp"
                                        *ngIf="DepartmentForm.controls['DeptCode'].touched && DepartmentForm.controls['DeptCode'].errors?.pattern">
                                        Invalid
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <div class="">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>Department Name</mat-label>
                                    <input appCamelcase maxlength="60" onkeydown="return (event.keyCode!=13);"
                                        [readonly]="isreaddelete" class="color" matInput formControlName="DeptName"
                                        placeholder="Department Name" required >
                                    <mat-error class="margin_tp"
                                        *ngIf="DepartmentForm.controls['DeptName'].touched && DepartmentForm.controls['DeptName'].errors?.required">
                                        Mandatory
                                    </mat-error>
                                    <mat-error class="margin_tp"
                                        *ngIf="DepartmentForm.controls['DeptName'].touched && DepartmentForm.controls['DeptName'].errors?.pattern">
                                        Invalid
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 row ">
                        <div class="col-sm-12 prpl">
                            <button id="Save" type="button" *ngIf="submitButton && DepartmentCreate" 
                            class="btn btn-primary btn-icon-text floatright mt-1"
                            (click)="submit()">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                {{'header.faculty-data.titleList.Save'
                                | translate}}
                            </span>
                        </button>
                        <button id="Update" type="button" *ngIf="editButton && DepartmentUpdate" 
                        class="btn btn-primary btn-icon-text floatright mt-1"
                        (click)="update()">
                        <span style="display: contents; align-items: center;">
                            <img width="20vh" src="../../assets/img/edit1.gif" style="margin-right: 5px;">
                            {{'header.faculty-data.titleList.Update'
                                | translate}}
                        </span>
                    </button>
                    <button id="Delete" type="button" *ngIf="deleteButton && DepartmentDelete" 
                    class="btn btn-primary btn-icon-text floatright mt-1"
                                (click)="DeletetheRecord()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/trash.gif" style="margin-right: 5px;">
                                    {{'header.faculty-data.titleList.Delete'
                                | translate}}
                                </span>
                            </button>
                            <button id="Back" type="button" [mat-dialog-close]="true"
                            class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                {{'header.faculty-data.titleList.Back'
                                | translate}}
                            </span>
                        </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>